import React from "react";
import {
  IWebsiteBuilderList,
  websiteBuilderGenerateListDesignStyles,
} from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderList";

interface IWebsiteBuilderListViewProps {
  node: IWebsiteBuilderList;
}

export function WebsiteBuilderListView(props: IWebsiteBuilderListViewProps) {
  const { node } = props;

  const settings = node.element.settings;
  const designStyles = websiteBuilderGenerateListDesignStyles();

  const ListTag = settings.type === "ordered" ? "ol" : "ul";

  return (
    <ListTag
      className={designStyles.className}
      style={designStyles.styleProperties}
    >
      {settings.items.map((item, index) => <li key={index}>{item}</li>)}
    </ListTag>
  );
}
